/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const file_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 5h5.5M7 8h8.5M7 19h7.5m6-11.134V22a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h10.036a1 1 0 0 1 .764.354l4.963 5.866a1 1 0 0 1 .237.646Z"
    />
  </svg>
)
export default file_medium
